import { useState, useRef } from "react";
import { toast } from "sonner";
import { Upload, Loader2, X } from "lucide-react";
import { api, resolveImg } from "@/lib/api";

export const ImageUpload = ({ label, value, onChange, testid }) => {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await api.post("/admin/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(res.data.url);
      toast.success("Foto geüpload");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload mislukt");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <label className="text-white/60 text-xs uppercase tracking-widest block mb-2">{label}</label>
      <div className="flex items-center gap-4">
        <div className="relative w-24 h-24 bg-[#0a0a0a] border border-white/10 overflow-hidden shrink-0 flex items-center justify-center">
          {value ? (
            <>
              <img src={resolveImg(value)} alt="" className="w-full h-full object-cover" />
              <button
                type="button"
                onClick={() => onChange("")}
                className="absolute top-1 right-1 bg-black/70 p-1 text-white hover:text-[#FF1A1A]"
              >
                <X size={14} />
              </button>
            </>
          ) : (
            <Upload size={20} className="text-white/30" />
          )}
        </div>
        <div className="flex-1">
          <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" data-testid={testid} />
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            className="border border-white/20 text-white text-sm px-4 py-2 hover:border-[#FF1A1A] transition-colors flex items-center gap-2 disabled:opacity-60"
          >
            {uploading ? <><Loader2 size={15} className="animate-spin" /> Uploaden...</> : <><Upload size={15} /> Foto kiezen</>}
          </button>
          <input
            type="text"
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="of plak een afbeeldings-URL"
            className="w-full bg-transparent border-b border-white/10 focus:border-[#FF1A1A] outline-none py-1.5 text-white/70 text-xs mt-2 placeholder:text-white/20"
          />
        </div>
      </div>
    </div>
  );
};

export default ImageUpload;
